<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Strabane
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Orders</a>
          <ul>
            <li @click="activeMenuLink = '/strabane/strabane-incoming-orders'"><router-link to="/strabane/strabane-incoming-orders"  :class="{'is-active':activeMenuLink === '/strabane/strabane-incoming-orders'}">Incoming Orders</router-link></li>
             <li @click="activeMenuLink = '/strabane/strabane-inprogress-orders'"><router-link to="/strabane/strabane-inprogress-orders"  :class="{'is-active':activeMenuLink === '/strabane/strabane-inprogress-orders'}">In Progress</router-link></li>
              <li @click="activeMenuLink = '/strabane/strabane-completed-orders'"><router-link to="/strabane/strabane-completed-orders"  :class="{'is-active':activeMenuLink === '/strabane/strabane-completed-orders'}">Completed</router-link></li>
          </ul>
        </li>
        
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
export default {
  name: 'SideBarStrabane',
  components: {
  },
  data() {
    return { activeMenuLink: null }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  }
}

</script>



